import { render } from "./BasePictureCompanyAvatar.vue?vue&type=template&id=455e43cd"
import script from "./BasePictureCompanyAvatar.vue?vue&type=script&lang=js"
export * from "./BasePictureCompanyAvatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__